import React from "react";
import { NavLink } from "react-router-dom";
import { getCustomUserAgent, getCustomUserAgentKrk } from "../../../customUserAgent";

import "../styles/Sidebar.css";
import {
  pathMain,
  pathContacts,
  pathNews,
  pathDemand,
  pathSchedule,
} from "../../../config/vars";
import { isIntfAccessDenied, keyIntfContacts, keyIntfDemands, keyIntfMap, keyIntfNews } from "../../../disabledInterfaces";
import { $SiteColors } from "../../../config/company-atts";

export const Sidebar = () => {
  const [openMenu, setOpenMenu] = React.useState(false);

  const buttonClassName = `${openMenu ? "sidebar__button sidebar__button_active" : "sidebar__button"
    }`;
  const sidebarClassName = `${openMenu ? "sidebar sidebar_active" : "sidebar"}`;

  function openCloseMenu() {
    setOpenMenu(!openMenu);
  }

  function closeByRedirect() {
    setOpenMenu(false);
  }

  return (
    <>
      <div className="sidebar__button-container">
        <button className={buttonClassName} onClick={openCloseMenu} >
          <span></span>
        </button>
      </div>
      <nav className={sidebarClassName} style={openMenu?{backgroundColor:"#fff"}:{}} >
        <NavLink
          exact
          to={pathMain}
          style={{color:$SiteColors.getState().sideBarText}}
          className="sidebar__link"
          activeClassName="sidebar__link_active"
          onClick={closeByRedirect}
        >
          Главная
        </NavLink>
        <NavLink
          hidden={isIntfAccessDenied(keyIntfNews)}
          to={pathNews}
          style={{color:$SiteColors.getState().sideBarText}}
          className="sidebar__link"
          activeClassName="sidebar__link_active"
          onClick={closeByRedirect}
        >
          Новости
        </NavLink>
        <NavLink
          hidden={isIntfAccessDenied(keyIntfDemands)}
          to={pathDemand}
          style={{color:$SiteColors.getState().sideBarText}}
          className="sidebar__link"
          activeClassName="sidebar__link_active"
          onClick={closeByRedirect}
        >
          Заявки
        </NavLink>
        <NavLink
          hidden={isIntfAccessDenied(keyIntfMap)}
          to={pathSchedule}
          style={{color:$SiteColors.getState().sideBarText}}
          className="sidebar__link"
          activeClassName="sidebar__link_active"
          onClick={closeByRedirect}
        >
          График мусоровозов
        </NavLink>

        <NavLink
          hidden={isIntfAccessDenied(keyIntfContacts)}
          to={pathContacts}
          style={{color:$SiteColors.getState().sideBarText}}
          className="sidebar__link"
          activeClassName="sidebar__link_active"
          onClick={closeByRedirect}
        >
          Связаться с УК
        </NavLink>
      </nav>
    </>
  );
};
